import React, { useState, useEffect } from 'react';
import api from '../../services/api';
import LoadingSpinner from '../common/LoadingSpinner';

function MasterDataManagement() {
  const [activeTab, setActiveTab] = useState('leadStatuses');
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showAdd, setShowAdd] = useState(false);
  const [editing, setEditing] = useState(null);
  const [formData, setFormData] = useState({ name: '', displayOrder: 0, isActive: 1 });

  const tabs = [
    { id: 'leadSources', label: 'Lead Sources' },
    { id: 'leadTypes', label: 'Lead Types' },
    { id: 'serviceDashboards', label: 'Service Dashboards' },
    { id: 'leadStatuses', label: 'Legacy Lead Statuses' },
    { id: 'demoStatuses', label: 'Demo Statuses' },
    { id: 'activityTypes', label: 'Activity Types' },
    { id: 'manufacturers', label: 'Manufacturers' }
  ];

  useEffect(() => {
    loadData();
  }, [activeTab]);

  const loadData = async () => {
    setLoading(true);
    try {
      const response = await api.getMasterData(activeTab);
      setData(response || []);
    } catch (err) {
      console.error('Failed to load data:', err);
      alert('Failed to load data');
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (editing) {
        await api.updateMasterData(activeTab, editing.id, formData);
      } else {
        await api.createMasterData(activeTab, formData);
      }
      loadData();
      setShowAdd(false);
      setEditing(null);
      setFormData({ name: '', displayOrder: 0, isActive: 1 });
    } catch (err) {
      console.error('Failed to save:', err);
      alert('Failed to save');
    }
  };

  const handleEdit = (item) => {
    setEditing(item);
    setFormData({
      name: item.name,
      displayOrder: item.display_order || 0,
      isActive: item.is_active
    });
    setShowAdd(true);
  };

  const handleDelete = async (id) => {
    if (window.confirm('Are you sure you want to delete this?')) {
      try {
        await api.deleteMasterData(activeTab, id);
        loadData();
      } catch (err) {
        console.error('Failed to delete:', err);
        alert('Failed to delete');
      }
    }
  };

  if (loading) return <LoadingSpinner message="Loading..." />;

  return (
    <div className="master-data-management">
      <div className="management-header">
        <h2>Master Data Management</h2>
        <button className="btn btn-primary" onClick={() => setShowAdd(true)}>
          <i className="fas fa-plus"></i> Add New
        </button>
      </div>

      <div className="admin-tabs">
        {tabs.map(tab => (
          <button
            key={tab.id}
            className={`admin-tab ${activeTab === tab.id ? 'active' : ''}`}
            onClick={() => setActiveTab(tab.id)}
          >
            {tab.label}
          </button>
        ))}
      </div>

      {showAdd && (
        <div className="modal-overlay">
          <div className="modal">
            <h2>{editing ? 'Edit' : 'Add New'} {tabs.find(t => t.id === activeTab)?.label}</h2>
            <form onSubmit={handleSubmit}>
              <div className="form-group">
                <label>Name *</label>
                <input
                  type="text"
                  className="form-control"
                  value={formData.name}
                  onChange={(e) => setFormData({...formData, name: e.target.value})}
                  required
                />
              </div>
              <div className="form-group">
                <label>Display Order</label>
                <input
                  type="number"
                  className="form-control"
                  value={formData.displayOrder}
                  onChange={(e) => setFormData({...formData, displayOrder: parseInt(e.target.value) || 0})}
                />
              </div>
              <div className="form-group">
                <label>Active</label>
                <select
                  className="form-control"
                  value={formData.isActive}
                  onChange={(e) => setFormData({...formData, isActive: parseInt(e.target.value)})}
                >
                  <option value={1}>Active</option>
                  <option value={0}>Inactive</option>
                </select>
              </div>
              <div className="modal-actions">
                <button type="button" className="btn btn-secondary" onClick={() => {
                  setShowAdd(false);
                  setEditing(null);
                  setFormData({ name: '', displayOrder: 0, isActive: 1 });
                }}>
                  Cancel
                </button>
                <button type="submit" className="btn btn-primary">
                  {editing ? 'Update' : 'Create'}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      <div className="table-wrapper">
        <table>
          <thead>
            <tr>
              <th>Name</th>
              <th>Display Order</th>
              <th>Status</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {data.map((item) => (
              <tr key={item.id}>
                <td><strong>{item.name}</strong></td>
                <td>{item.display_order || 0}</td>
                <td>
                  <span className={`status-badge ${item.is_active ? 'active' : 'inactive'}`}>
                    {item.is_active ? 'Active' : 'Inactive'}
                  </span>
                </td>
                <td className="actions">
                  <button className="btn btn-sm btn-secondary" onClick={() => handleEdit(item)}>
                    <i className="fas fa-edit"></i>
                  </button>
                  <button className="btn btn-sm btn-danger" onClick={() => handleDelete(item.id)}>
                    <i className="fas fa-trash"></i>
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default MasterDataManagement;